import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'

import { useAdDisabledStore } from '@/store/ad-disabled-store'

import type { AdInfo } from '../types'

export type AdDisabledReason = 'ad-free-mode' | 'ad-disabled'

export function useDisabledAdFiller(updateAdInfo: (patch: Partial<AdInfo>) => void) {
    const resolveDisabledAdFiller = ref<(options: { reason: AdDisabledReason }) => void>()
    const { isAdFreeActive, isAdDisabled } = storeToRefs(useAdDisabledStore())
    const reason = computed<AdDisabledReason>(() => (isAdFreeActive.value ? 'ad-free-mode' : 'ad-disabled'))
    function disabledAdFillerHandler(message: { type: string; secondsLeft?: number }) {
        if (message.type === 'timer') {
            updateAdInfo({ isVisible: true, secondsLeft: message.secondsLeft })
        }
        if (message.type === 'stop') {
            updateAdInfo({ isVisible: false })
            resolveDisabledAdFiller.value?.({ reason: reason.value })
            resolveDisabledAdFiller.value = undefined
        }
    }

    function adDisabledHandler(adAction?: string): Promise<{ reason: AdDisabledReason }> | null {
        if (!isAdDisabled.value) {
            return null
        }

        if (adAction === 'showRewarded') {
            return new Promise((resolve) => {
                resolveDisabledAdFiller.value = resolve
            })
        }

        return Promise.resolve({ reason: reason.value })
    }

    const isDisabledAdFillerVisible = computed(() => !!resolveDisabledAdFiller.value)

    return { disabledAdFillerHandler, adDisabledHandler, isDisabledAdFillerVisible }
}
